import React from 'react';
import { HeadingLevelProvider } from '@zapier/heading-level-context';
import { GuidedRecipeShort } from 'data/Article/types';
import { ZapCard } from '@zapier/design-system-patterns';
import { ZapTemplateDetails } from 'components/ZapTemplate/ZapTemplateDetails';
import styled from '@emotion/styled';
import { OptionSelected, useAvroTracking } from 'tracking/avro';
import { ComputedState } from '@zapier/design-system-patterns/cjs/components/ZapCard/ZapCard';

type Props = {
  template: GuidedRecipeShort;
};

export const ZapTemplate: React.FC<Props> = ({ template }: Props) => {
  const { emitCTAClickEvent, emitToggleClickEvent } = useAvroTracking();

  const onClickZapCard = (
    e: React.MouseEvent<Element, MouseEvent>,
    computedState: ComputedState,
  ) => {
    if (!(e.target instanceof HTMLElement)) return;

    const isButtonClick = e.target.innerText === 'Try it';

    if (isButtonClick) {
      emitCTAClickEvent({
        destination_url_address: template.editorUrl!,
        option_selected: OptionSelected.cta_button,
        interaction_raw_text: 'Try it',
        custom_tracking_fields: {
          component: 'ZapTemplate',
          template_id: template.id,
        },
      });
    } else if (e.target.tagName.toLowerCase() === 'summary') {
      emitToggleClickEvent({
        option_selected: computedState.isExpanded
          ? OptionSelected.closing
          : OptionSelected.opening,
        interaction_raw_text: template.title,
        custom_tracking_fields: {
          component: 'ZapTemplate',
          template_id: template.id,
        },
      });
    }
  };
  return (
    <Wrapper data-testid="zap-template">
      <HeadingLevelProvider level={3}>
        <ZapCard
          title={template.title}
          services={template.services.map((service) => ({
            name: service.name,
            src: service.images.url_32x32,
          }))}
          hrefTarget="_blank"
          layout="auto"
          onClick={onClickZapCard}
          href={template.editorUrl}
        >
          <ZapTemplateDetails template={template} />
        </ZapCard>
      </HeadingLevelProvider>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 5px 0;
`;
